<template>
  <!-- 战团管理-成员列表-个人红包记录 -->
  <div>
    <el-dialog
      :visible.sync="showMark"
      :close-on-click-modal="false"
      title="个人红包记录"
      width="800px"
      @close="closeDialog"
      center
    >
      <el-table
        height="300"
        class="from-overview"
        v-loading="loading"
        :data="dataList"
      >
        <el-table-column prop="amount" label="钻石金额" align="center">
        </el-table-column>
        <el-table-column prop="created_at" label="发放时间" align="center">
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { server, postData, delData, patchData, getData, postApiData } from '../../http'

export default {
  components: {
  },
  props: {
    value: {
      type: Object,
      default: undefined
    },
    visible: {//展示标志
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//加载按钮动画
      query: {//查询
        page: 1
      },
      dataList: undefined,//数据列表
      dataMeta: undefined,//不底部分页
    }
  },
  computed: {
    ...mapState({
    }),
    showMark: {
      get() {
        return this.visible
      },
      set(bool) {
      }
    },
    dialogInfos: {
      get() {
        return this.value
      },
      set(bool) {
      }
    }
  },
  watch: {
    showMark(val) {
      if (val) {
        this.getData()//获取数据列表
      }
    }
  },
  created() {
  },
  mounted() { },
  methods: {
    ...mapMutations(['']),
    ...mapActions(['']),
    getData() {
      //获取数据列表
      this.loading = true
      let params = {
        page: this.query.page,
        type: 2,
        id: this.dialogInfos.user_id
      }
      getData(`team_red_record`, params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    },

  }

}
</script>
<style lang="less" scoped>
</style>